import SaveIcon from '@material-ui/icons/Save';
import CancelIcon from '@material-ui/icons/Cancel';
import SendIcon from '@material-ui/icons/Send';
import AddShoppingCartIcon from '@material-ui/icons/AddShoppingCart';
import FilterListIcon from '@material-ui/icons/FilterList';
import DateFnsUtils from '@date-io/date-fns';
import React, { useEffect, useState } from 'react';
import trLocale from 'date-fns/locale/tr';
import CloseIcon from '@material-ui/icons/Close';
import ImageSearchIcon from '@material-ui/icons/ImageSearch';
import SearchIcon from '@material-ui/icons/Search';
import SearchBar from 'material-ui-search-bar';
import LocalGroceryStoreIcon from '@material-ui/icons/LocalGroceryStore';
import { sc, moneyFormat } from 'src/utils/Common';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import ThumbUpAltIcon from '@material-ui/icons/ThumbUpAlt';
import ControlCameraIcon from '@material-ui/icons/ControlCamera';
import XLSX from 'xlsx';
import axiosServiceShop from 'src/utils/customAxios';
import {
  Card,
  Avatar,
  Input,
  DialogContent,
  DialogContentText,
  Breadcrumbs,
  Link,
  Typography,
  CardContent,
  Container,
  Divider,
  Dialog,
  DialogTitle,
  DialogActions,
  BottomNavigation,
  BottomNavigationAction,
  Grid,
  IconButton,
  TextField,
  ThemeProvider,
  MenuItem,
  createMuiTheme,
  CardHeader,
  Box,
  FormControlLabel,
  Backdrop,
  CircularProgress,
  Button,
  Snackbar,
  TablePagination, ListItemAvatar, ListItem, ListItemText, List, OutlinedInput, InputAdornment
} from '@material-ui/core';
import {
  KeyboardDatePicker,
  MuiPickersUtilsProvider
} from '@material-ui/pickers';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Page from 'src/components/Page';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import AddBoxIcon from '@material-ui/icons/AddBox';
import DeleteIcon from '@material-ui/icons/Delete';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import moment from 'moment';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { retry } from '@redux-saga/core/effects';
import Alert from 'src/components/Alert';
import ExcelExport from 'src/components/ExcelExport';
import UrunSearch from '../../components/Selects/ProductSearch';
import ProductMaterialSearch from 'src/components/Selects/ProductMaterialSearch'
import {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
} from '../../store/actions';
import RetailerSearchShipTo from 'src/components/Selects/RetailerSearchShipTo';
import EditMaterial from 'src/components/SelectMaterial/materialOrderEdit';
import LocalShippingIcon from '@material-ui/icons/LocalShipping';

const useStyles = makeStyles(theme => ({
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0)'
  },
  root: {
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2)
  },
  cardscontent: {
    minHeight: 300
  },
  backdrop: {
    zIndex: 1500,
    color: '#fff'
  },
  tableRow: {
    '&$hover:hover': {
      backgroundColor: '#f5f5f5'
    }
  },
  tableCell: {
    '$hover:hover &': {
      color: 'black'
    }
  },
  hover: {},
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
}));

const EXTENSIONS = ['xlsx', 'xls', 'csv']

const MaterialOrder = props => {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [SelectedMaterialPopup, setSelectedMaterialPopup] = useState(false);
  const [SelectedProductMaterialPopup, setSelectedProductMaterialPopup] = useState(false);
  const [MaterialData, setMaterialData] = useState({});
  const [UrunData, setUrunData] = useState({});
  const [search] = useState('');
  const [TopBarValue, setTopBarValue] = React.useState(-1);
  const SessionUser = getUser();
  const [stokOpen, setStokOpen] = React.useState(false);
  const [stokData, setStokData] = React.useState([]);
  const [ErpStatusOpen, setErpStatusOpen] = React.useState(false);
  const [ErpStatusData, setErpStatusData] = React.useState([]);
  const [MissingMaterialsPopUp, missingMaterialsPopUp] = React.useState(false);
  const [MissingMaterials, missingMaterials] = React.useState([]);
  const [openEdit, setOpenEdit] = React.useState(false);
  const [materialId,setMaterialId] = React.useState('');
  const [materialCode,setMaterialCode] = React.useState('');
  const [materialDesc,setMaterialDesc] = React.useState('');
  const [sparePartMessage, setSparePartMessage] = React.useState('');
  const [sparePartMap, setSparePartMapData] = React.useState([]);
  const [ShipToPopUp,setShipToPopUp] = useState(false);
  const [materialAvailabilityCode,setMaterialAvailabilityCode] = React.useState([]);
  //dropshipment
  const [title,setTitle] = useState("");
  const [name,setName] = useState("");
  const [street,setStreet] = useState("");
  const [country,setCountry] = useState("");
  const [postalCode,setPostalCode] = useState("");
  const [city,setCity] = useState("");
  const [district,setDistrict] = useState("");
  const [region,setRegion] = useState("");
  //
  const [QuantityState, setQuantityState] = useState({
    value:1,
    show:1,
    backgroundColor:'white',
});


  const [statusList] = useState([
    { Id: 1, Name: t('lblNew') },
    { Id: 2, Name: t('lblCancel') },
    { Id: 3, Name: t('lblReject') },
    { Id: 4, Name: t('lblSubmittedforApproval') },
    { Id: 5, Name: t('lblSAPSent') }
  ]);
  const [selectedStatus, setSelectedStatus] = useState({ Id: 1, Name: 'New' });
  const [StartDateSearch, setStartDateSearch] = useState(
    moment()
      .startOf('day')
      .add(-7, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD')
  );
  const [SearchOrderParam, setSearchOrderParam] = React.useState('');
  const [EndDateSearch, setEndDateSearch] = useState(new Date());
  const [SparepartData, setSparePartData] = useState([]);
  const [QueryPopUp, setQueryPopUp] = useState(false);
  const [ServiceShopData, SetServiceShopData] = useState([]);
  const [serviceShopId, setServiceShopId] = useState('');
  const [openSnackbar, setOpenSnackbar] = React.useState(false);
  const [ResponseType, setResponseType] = useState('success');
  const [scroll, setScroll] = React.useState('paper');
  //const [ExportPopup, setExportPopup] = React.useState(false);
  const [initialRows, setinitialRows] = useState('');

  const exportMaterialData = (data) => {
    var json = []
    for (let i = 0; i < data?.length; i++) {
      var temp = {};
      temp.ProductId = data[i].ProductId;
      temp.lblProductName = data[i].ProductName;
      temp.MaterialCode = data[i].MaterialCode;
      temp.MaterialDesc = data[i].MaterialDesc;
      temp.Ref = data[i].Ref;
      temp.lblQuantity = data[i].Quantity;
      temp.UseQuantity = data[i].UseQuantity;
      temp.Price = SessionUser.ServiceShopPriceVisible ? data[i].Price : 0;
      temp.PriceWithWat = SessionUser.ServiceShopPriceVisible ? data[i].PriceWithWat : 0;
      temp.lblTotal = SessionUser.ServiceShopPriceVisible ? data[i].Total : 0;
      json.push(temp)
    };

    return json
  };
  
  const exportExcelExample = [{
      'MaterialCode':'',
      'Quantity':''
  }];

  const getStokColor = s => {
    if (s.Quantity !== "0,0") {
      return (
        <Avatar
          size="small"
          style={{ color: 'white', backgroundColor: 'green' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    } else {
      return (
        <Avatar
          size="small"

          style={{ color: '#424242', backgroundColor: 'red' }}
        >
          <ShoppingCartIcon />
        </Avatar>
      );
    }
  };
  const defaultMaterialOrder = {
    service: SessionUser.ServiceShopName,
    orderNumber: 0,
    orderDate: moment().format('YYYY-MM-DD'),
    sapNumber: '',
    jobNumber: '',
    poNumber: '',
    modelCode: '',
    status: statusList[0].Name,
    recipientName: '',
    recipientId: 0,
    description: '',
    recipientAddress: '',
    ServiceShopId:
      SessionUser.Role === 1 || SessionUser.Role === 2 || SessionUser.Role === 5
        ? SessionUser.ServiceShopId
        : 0
  };

  const DefaultWorkCase = {
    ConsumerId: 0,
    ProductId: 0,
    ProductionYear: 0,
    ProductionMonth: 0,
    SerialNr: '0',
    Product: '',
    OnSiteOperation: 0,
    WarrantyTypeId: 0,
    IssueId: 1,
    Issue: '',
    RetailerId: 0,
    Retailer: '',
    StatusId: 1,
    Comment: '',
    WarrantyDate: '01.01.2021',
    AppointmentDate: moment()
      .startOf('day')
      .add(1, 'days')
      .add(12, 'hours')
      .format('YYYY-MM-DD hh:mm'),
    AppointmentEndDate: moment()
      .startOf('day')
      .add(1, 'days')
      .add(13, 'hours')
      .format('YYYY-MM-DD hh:mm')
  };



  const [MaterialOrderData, setMaterialOrderData] = useState(
    defaultMaterialOrder
  );
  const [MaterialListData, setMaterialListData] = useState([]); //Product-Material
  const [MaterialListData2, setMaterialListData2] = useState([]); //Only Material

  const [retailerData, setRetailerData] = useState([]);
  const [selectedRetailer, setSelectedRetailer] = useState(0);
  const [address, setAddress] = useState('');

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [loading, setLoading] = useState(false);
  const [loading2, setLoading2] = useState(false);
  const [QuerySearchData, setQuerySearchData] = useState([]);
  const [QuerySearchScreenData, setQuerySearchScreenData] = useState([]);
  const [ResponseDsc, setResponseDsc] = useState('');
  const [ImagePopup, setImagePopup] = useState(false);
  const [ImageUrl, setImageUrl] = useState('');
  const [currentStatus, setCurrentStatus] = useState(0);
  const [searched, setSearched] = useState('');
  const [DisabledControl, setDisabledControl] = useState(false);
  const [NewWorkCaseData, setNewWorkCaseData] = useState(DefaultWorkCase);
  const [inputText, setInputText] = useState("");
  const [ServiceShopShipToCode,setServiceShopShipToCode] = useState(null)
  const [openWarning, setopenWarning] = React.useState(false);
  const [Uyari, setUyari] = React.useState('');
  const [anchorEl, setAnchorEl] = React.useState(null);
  useEffect(() => {
    if (props?.MaterialOrderIdPopup > 0) {
      setSearchOrderParam(props?.MaterialOrderIdPopup);
      GetMaterialOrderParamNew(props?.MaterialOrderIdPopup);
    }
  }, [props?.MaterialOrderIdPopup]);


  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;
  useEffect(() => {
    if (parseInt(SessionUser.Role) === 1 || parseInt(SessionUser.Role) === 2 || parseInt(SessionUser.Role) === 5) {

      setDisabledControl(true);
      setServiceShopId({ ServiceShopId: SessionUser.ServiceShopId });
    }
  }, [SessionUser.Role]);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeStartDateSearch = e => {
    setStartDateSearch(e);
  };
  const handleChangeEndDateSearch = e => {
    setEndDateSearch(e);
  };

  const GetMaterialOrderRequest = () => {
    if (!serviceShopId?.ServiceShopId) {
      return
    }
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: selectedStatus.Id,
      StartDate,
      EndDate,
      ServiceShopId: serviceShopId.ServiceShopId,
      OrderNr: MaterialOrderData.orderNumber | 0
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const GetServiceShopRequest = () => {
    axios
      .get('/GetServiceShopRequest/')
      .then(response => {
        if (response.data.length > 0) {
          SetServiceShopData(response.data);
          setServiceShopId(
            response.data[
            response.data.findIndex(
              x => x.ServiceShopId == SessionUser.ServiceShopId
            )
            ]
          );
          setServiceShopShipToCode(response.data[
            response.data.findIndex(
              x => x.ServiceShopId == SessionUser.ServiceShopId)
            ].ShipTo
          )
        }
      })
      .catch(error => { });
  };

  const GetRetailer = () => {
    var code = ServiceShopData.find(x => x.ServiceShopId == SessionUser.ServiceShopId)?.ShipTo;
    axios
      .get('/GetRetailer/0/' + code) 
      .then(response => {
        if (response.data.length > 0) {
          setRetailerData(response.data);
        }
      })
      .catch(error => { });
  };
  

  const handleRetailerChange = (event, newValue) => {
    setSelectedRetailer(newValue);
    if (newValue) {
      setAddress(newValue.Address);
    } else {
      setAddress('');
    }
  };

  const handleAddressChange = (event) => {
    setAddress(event.target.value);
  };

  useEffect(() => {
    GetServiceShopRequest();
  }, [locale]);
  
  useEffect(() => {
    GetRetailer();
  }, [ServiceShopData]);

  

  const localeMap = {
    tr: trLocale
  };

  const locale = localStorage.getItem('i18nextLng');

  const siyah = '#424242';
  
  const materialTheme = createMuiTheme({
    palette: {
      primary: {
        contrastText: '#FFFFFF',
        dark: siyah,
        main: siyah,
        light: siyah
      }
    }
  });

  const ValidateFields = () => {
    const descIsNull = !!(
      MaterialOrderData.description == '' ||
      MaterialOrderData.description == undefined
    );
    const recipientNameIsNull = !!(
      MaterialOrderData.recipientName == '' ||
      MaterialOrderData.recipientName == undefined
    );
    const recipientAddressIsNull = !!(
      MaterialOrderData.recipientAddress == '' ||
      MaterialOrderData.recipientAddress == undefined
    );
    const sparePartListIsEmpty = SparepartData.length === 0;

    const quantities = SparepartData.some((el)=>el.Quantity < 1);

    if (
      // descIsNull ||
      //recipientNameIsNull ||
      //recipientAddressIsNull ||
      sparePartListIsEmpty || quantities
    ) {
      return false;
    }

    return true;
  };

  function saveWorkOrder(StatusId) {
    if (ValidateFields()) {
      setLoading(true);
      const SetMaterialOrderDetailRequestDto = [];
      for (let i = 0; i < SparepartData.length; i++) {
        const tmpSparePartData = {
          Id: MaterialOrderData.orderNumber,
          RowId: i + 1,
          MaterialId: SparepartData[i].MaterialId,
          Qty: SparepartData[i].Quantity,
          ProductId: SparepartData[i].ProductId,
          CreateEmployeeId: SessionUser.TechnicianId,
          CreateDate: moment()
        };

        SetMaterialOrderDetailRequestDto.push(tmpSparePartData);
      }

      const setMaterialRequestDto = {
        Id: MaterialOrderData.orderNumber,
        ServiceShopId: serviceShopId.ServiceShopId,
        OrderDate: MaterialOrderData.orderDate,
        StatusId,
        WorkOrderId: MaterialOrderData.jobNumber || 0,
        PONumber: MaterialOrderData.poNumber,
        Dsc: MaterialOrderData.description,
        RecipientId: selectedRetailer.Id,
        RecipientDsc: selectedRetailer.Dsc,
        RecipientAddress: selectedRetailer.Address,
        AcceptDate: MaterialOrderData.orderDate,
        SapNr: MaterialOrderData.SapNr,
        CreateEmployeeId: SessionUser.TechnicianId,
        CreateDate: moment(),
        MaterialOrderDetails: SetMaterialOrderDetailRequestDto,
        RetailerId: MaterialOrderData.RetailerId
      };

      const config = {
        headers: { 'Content-Type': 'application/json' }
      };

      axios
        .post('/SetMaterialOrder', setMaterialRequestDto, config)
        .then(response => {
          if (response.data.IsSuccess) {
            const tmpStatus = statusList.find(x => x.Id === StatusId).Name;
            setMaterialOrderData({
              ...MaterialOrderData,
              orderNumber: response?.data?.OrderNr,
              sapNumber: response?.data?.SapNr,
              status: tmpStatus
            });
            setCurrentStatus(StatusId);
            setResponseType('success');
            setResponseDsc(t('success_message'));
            setOpenSnackbar(true)
            setTimeout(() => {setOpenSnackbar(false)},1000);
            //Dropshipment tamamlandıktan sonra açılacak
            // if(MaterialOrderData.recipientId != 0){
            //   const tmpStatus = statusList.find(x => x.Id === StatusId).Name;
            // setMaterialOrderData({
            //   ...MaterialOrderData,
            //   orderNumber: response?.data?.OrderNr,
            //   sapNumber: response?.data?.SapNr,
            //   status: tmpStatus
            // });
            // setCurrentStatus(StatusId);
            // setResponseType('success');
            // setResponseDsc(t('success_message'));
            // setOpenSnackbar(true)
            // setTimeout(() => {setOpenSnackbar(false)},1000);
            // }else{
            //   if(title != "" && name != "" && street != "" && country != "" && postalCode != "" && city != "" && district != ""){
            //     const tmpStatus = statusList.find(x => x.Id === StatusId).Name;
            //   setMaterialOrderData({
            //     ...MaterialOrderData,
            //     orderNumber: response?.data?.OrderNr,
            //     sapNumber: response?.data?.SapNr,
            //     status: tmpStatus
            //   });
            //   addToMaterialOrderDropShipment(response?.data?.OrderNr);
            //   setCurrentStatus(StatusId);
            //   setResponseType('success');
            //   setResponseDsc(t('success_message'));
            //   setOpenSnackbar(true)
            //     setTimeout(() => { setOpenSnackbar(false) }, 1000); 
            //   }else{
            //     setResponseType('error');
            //     setResponseDsc(t('lblMustDropShipment'));
            //     setOpenSnackbar(true);
            //   }
            // }
          } else {
            setResponseType('error');
            setResponseDsc(response.data.ErrorMessage || t('lblMustRole'));
            setOpenSnackbar(true);
          }
          setLoading(false);
        })
        .catch(error => {
          setLoading(false);
        });
    } else {
      handleSnackbarClick();
    }
  }

  function addToMaterialOrderDropShipment(MaterialOrderId){
    const setMaterialOrderDropShipmentRequest = {
      MaterialOrderId: MaterialOrderId,
      Title: title,
      Name: name,
      Street: street,
      Country: country,
      PostalCode: postalCode,
      City: city,
      District: district,
      Region: region
    };

    const config = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post(`SetMaterialOrderDropShipment`, setMaterialOrderDropShipmentRequest, config)
      .then(response => {
        
        if (response.data.ErrorCode != 1000) {
          setResponseType('success');
          setResponseDsc(t('success_message'));
          setOpenSnackbar(true)
          setTimeout(() => {setOpenSnackbar(false)},1000);
        } else {
          setResponseType('error');
          setResponseDsc(response.data.ErrorMessage || t('lblMustRole'));
          setOpenSnackbar(true);
        }
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
  }

  const GetMaterialOrderDropShipment = (MaterialOrderId) => {
    clearPage();
    setLoading(true);

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .get('/GetMaterialOrderDropShipment' + '/' + MaterialOrderId, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setTitle(Response[0].Title);
          setName(Response[0].Name);
          setCountry(Response[0].Country);
          setCity(Response[0].City);
          setDistrict(Response[0].District);
          setRegion(Response[0].Region);
          setStreet(Response[0].Street);
          setPostalCode(Response[0].PostalCode);
        }
        setLoading(false);
      })
      .catch(error => {
        setResponseType('error');
        setResponseDsc(Response.ErrorMessage || t('lblError'));
        setOpenSnackbar(true);
        setLoading(false);
      });
  };

  function addToMaterialTable(row) {
    axios
      .get(`/GetSparePartMapList` + '/' + row.MaterialId)
      .then(response => {
        if (response.data.length > 0 && response.data !== "") {
            setSparePartMapData(response.data);
            var message = t('MaterialHasEquivalent') + ' ' + row.MaterialCode + ' -> ' + response.data[0].NewMaterialCode;
            setSparePartMessage(message);
        }else{
          setSparePartMessage('');
        }
    
        const tmpRow = row;
        const tmpList = [...SparepartData];
        const ifAlreadyHaveItem = tmpList.find(
          x => x.MaterialId === tmpRow.MaterialId
        );
        if (ifAlreadyHaveItem === undefined || ifAlreadyHaveItem === null) {
          tmpRow.Quantity = 1;
          tmpRow.Total = tmpRow.Quantity * tmpRow.PriceWithWat;
          tmpList.push(tmpRow);
        } else {
          const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
          tmpList[index].Quantity += 1;
          tmpList[index].Total = 
            tmpList[index].Quantity * tmpList[index].PriceWithWat;
        } 
    
        setSparePartData(tmpList);
        setMaterialId(row.MaterialId);
        setMaterialCode(row.MaterialCode);
        setMaterialDesc(row.MaterialDesc);
        setOpenEdit(true);
  })
    .catch(error => { });
  }

  const handleQuantityChange = (e,row) => {
      const tmpRow = row;
      const tmpList = [...SparepartData];
      const ifAlreadyHaveItem = tmpList.find(
          x => x.MaterialId === tmpRow.MaterialId
        );
  
      if (ifAlreadyHaveItem === undefined || ifAlreadyHaveItem === null) {
          tmpRow.Quantity = 1;
          tmpRow.Total = tmpRow.Quantity * tmpRow.PriceWithWat;
          tmpList.push(tmpRow);
      } else {
          var quantity = e.target.value;
          
          // Quantity rules
          if(quantity > 100)
          {
            quantity = 100
          }
          else if(quantity < 0)
          {
            quantity = 0
          }

          const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
          tmpList[index].Quantity = quantity;
          tmpList[index].Total = 
            tmpList[index].Quantity * tmpList[index].PriceWithWat;
          }
      
      setSparePartData(tmpList);
      setQuantityState({value: quantity, backgroundColor: quantity > 0 ? 'white':'red'})
  }

  const deleteFromMaterialTable = row => {
    const tmpListData = [...SparepartData];
    const index = tmpListData.findIndex(x => x.MaterialId === row.MaterialId);
    tmpListData.splice(index, 1);
    setSparePartData(tmpListData);
  };

  const decrementFromMaterialTable = row => {
    const tmpRow = row;
    const tmpList = [...SparepartData];
    const index = tmpList.findIndex(x => x.MaterialId === tmpRow.MaterialId);
    if (tmpList[index].Quantity === 1) {
      // deleteFromMaterialTable(row)
    } else {
      tmpList[index].Quantity -= 1;
      tmpList[index].Total =
        tmpList[index].Quantity * tmpList[index].PriceWithWat;
      setSparePartData(tmpList);
    }
  };

  const clearPage = () => {
    setMaterialOrderData(defaultMaterialOrder);
    setMaterialListData([]);
    setMaterialListData2([]);
    setSparePartData([]);
    setTitle("");
    setName("");
    setCountry("");
    setCity("");
    setDistrict("");
    setRegion("");
    setStreet("");
    setPostalCode("");
  };

  const SetDate = value => {
    const DateValue = moment(value).format('YYYY-MM-DD');
    setMaterialOrderData({ ...MaterialOrderData, orderDate: DateValue });
  };

  const setModel = param => {

    setMaterialListData([]);
    const job = {
      ModelCode: param.KUL_MODEL_KODU,
      Model: param.ACIKLAMA,
      HomeWhiz: param.HOMEWHIZ,
      BrandCode: param.MARKA_KODU,
      ProductId: param.MODEL_KODU
    };

    setUrunData(job);

    setLoading(true);
    axios
      .get(`/GetSiriusMaterials/${param.KUL_MODEL_KODU}/1/1/1/1/${SessionUser.ServiceShopId}/${SessionUser.TechnicianId}/-1`)
      .then(response => {
        setLoading(false);
        if (response.data.length > 0) {
          response.data.forEach(element => {
            element.ProductId = param.MODEL_KODU
            element.ProductName = param.ACIKLAMA
          });
          setMaterialListData(response.data);
          setinitialRows(response.data);
        } else {
          setMaterialListData([]);
        }
      })
      .catch(error => {
        setLoading(false);
      });
  };

  const setSearchMaterial = param => {
    setMaterialListData2([]);
    const job = {
      MaterialCode: param.MaterialCode, //M.Code
      Material: param.MaterialDesc, //T.FieldText
    };
    setMaterialData(job);

    setLoading(true);
    axios
    .get(`/GetSiriusMaterialsBySearchKey/${inputText.toLocaleLowerCase(localStorage.i18nextLng_normalized)}/${SessionUser.ServiceShopId}`)
    .then(response => {
      setLoading(false);
      if (response.data.length > 0) {
        response.data.forEach(element => {
          element.Code = param.MaterialCode
          element.MaterialName = param.MaterialDesc
        });
        setMaterialListData2(response.data);
        setinitialRows(response.data);
      }else{
        setMaterialListData([]);
        const informationAlert = t('lblMissingMaterial');
        setUyari(informationAlert);
        setopenWarning(true);
      }
    })
    .catch(error => {
      setLoading(false);
    });
  }

  // Import excel function
  function setSearcByExcelhMaterial (excelData) {
    setMaterialListData2([]);

    setLoading(true);
    
    const request = {
      ExcelDataFormat : excelData,
      ServiceShopId: JSON.stringify(SessionUser.ServiceShopId)
    }
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    // A comparer used to determine if two entries are equal.
    const isSameMaterial = (a, b) => a.MaterialCode === b.MaterialCode;

    const onlyInLeft = (left, right, compareFunction) => 
  left.filter(leftValue =>
    !right.some(rightValue => 
      compareFunction(leftValue, rightValue)));

    axiosServiceShop // service shop url
    .post('/GetSiriusMaterialByExcelData', request,config)
    .then(response => {
      setLoading(false);
      if (response.data.length > 0) {
        response.data.forEach(element => {
          element.Total = element.Quantity * element.PriceWithWat;
        });

        var missingValues = onlyInLeft(excelData,response.data,isSameMaterial);

        setMaterialListData2(response.data); // Material Choose popup
        setSparePartData(response.data); // Table
        setinitialRows(response.data);
        
        if(missingValues.length > 0)
        {
          missingMaterials(missingValues);
          missingMaterialsPopUp(true);
        }

        setSelectedMaterialPopup(false); // Close popup
      }else{
        setMaterialListData([]);
      }
    })
    .catch(error => {
      setLoading(false);
    });
  }

  const handleChangeRowsPerPage = event => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const malzemeGosterMaterial = materialCode => {
    const data = {
      MaterialCode: materialCode
    };
    const config = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/FileImportExport/SiriusMaterialImage', data, config)
      .then(response => {
        const fileURL = URL.createObjectURL(response.data);

        // newWindow.location = fileURL;
        // newWindow.document.title = materialCode;
        setImageUrl(fileURL);
        setImagePopup(true);
      })
      .catch(error => { });
  };

  const updateWorkOrder = statusId => {
    saveWorkOrder(statusId);
  };

  const changeSelectedStatus = status => {
    setSelectedStatus(status);
  };
  const handleSnackbarClick = () => {
    setResponseType('error');
    setResponseDsc(t('lblMissingFields'));
    setOpenSnackbar(true);
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }

    setOpenSnackbar(false);
  };

  const setQuery = row => {

    const defaultMaterialOrderParam = {
      ServiceShopId: row.ServiceShopId,
      service: `${row.SourceServiceShopCode} ${row.ServiceShop}`,
      orderNumber: row.MaterialOrderId,
      orderDate: row.OrderDate,
      sapNumber: row.SapNr ? row.SapNr : '',
      jobNumber: row.WorkOrderId ? row.WorkOrderId : '',
      poNumber: row.PONumber ? row.PONumber : '',
      modelCode: '',
      status: row.MaterialOrderStatus,
      recipientName: row.RecipientDsc,
      description: row.Dsc ? row.Dsc : '',
      recipientAddress: row.RecipientAddress,
      recipientId: row.RecipientId
    };

    const DetailData = [];
    row.MaterialOrderDetails.forEach(item => {
      const Data = {};
      Data.MaterialId = item.MaterialId;
      Data.MaterialCode = item.MaterialCode;
      Data.MaterialDesc = item.Material;
      Data.Quantity = item.Qty;
      Data.UseQuantity = item.OriginalQty;
      Data.Price = SessionUser.ServiceShopPriceVisible ? item.Price : 0;
      Data.PriceWithWat = SessionUser.ServiceShopPriceVisible ? item.PriceWithWat : 0;
      Data.Total = SessionUser.ServiceShopPriceVisible ? item.PriceWithWat * item.Qty : 0;
      Data.ProductId = item.ProductId
      Data.ProductName = item.ProductName
      DetailData.push(Data);
    });

    setCurrentStatus(row.StatusId);
    setMaterialOrderData(defaultMaterialOrderParam);
    setSparePartData(DetailData);
    setQueryPopUp(false);
    // setQuerySearchScreenData([]); //query'de bir satıra tıklandıktan sonra tekrar query'e baktığımızda içinin boş gelmemesi
  };


  const requestSearch = (searchedVal) => { //Product-Material -Material Search
    const filteredRows = initialRows.filter((item) => sc(
      item.MaterialCode + item.MaterialDesc + item.Ref + item.PriceWithWat.toFixed(2),
      searchedVal
    ));
    setMaterialListData(filteredRows);
    setPage(0);
  };

  const requestSearch2 = (searchedVal) => { //Only Material -Material Search
    const filteredRows = initialRows.filter((item) => sc(
      item.MaterialCode + item.MaterialDesc + item.PriceWithWat.toFixed(2),
      searchedVal
    ));
    setMaterialListData2(filteredRows);
    setPage(0);
  };

  const cancelSearch = () => {
    setSearched('');
    requestSearch(searched);
  };

  const StokControlPopup = (row) => {
    axios
      .get('/GetMaterialAvailabilitySirius/' + row.MaterialCode + '/' + SessionUser.ServiceShopCode)
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setStokData(res);
        setMaterialAvailabilityCode(row.MaterialCode);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setStokOpen(true);
  }


  const ErpStatusPopup = (ErpNr) => {
    axios
      .get('/GetErpWarehouseMaterialStatus/' + ErpNr + '/' + localStorage.getItem('i18nextLng'))
      .then(response => {
        const res = response.data.length === 0 ? [] : response.data;
        setErpStatusData(res);
        setLoading(false);
      })
      .catch(error => {
        setLoading(false);
      });
    setErpStatusOpen(true);
  }

  const exportData = (data) => {
    var json = []

    data.map(row => (
      row.MaterialOrderDetails ? row.MaterialOrderDetails.map(det => {
        var temp = {};
        temp.lblWorkOrderId = row.WorkOrderId;
        temp.lblServiceShop = `${row.SourceServiceShopCode} ${row.ServiceShop}`;
        temp.lblMaterialOrderId = row.MaterialOrderId;
        temp.lblRecipientDsc = row.RecipientDsc;
        temp.lblRecipientAddress = row.RecipientAddress;
        temp.lblRecipientId = row.RecipientId;
        temp.lblMaterialCode = det.MaterialCode;
        temp.lblMaterial = det.Material;
        temp.lblQuantity = det.Qty;
        temp.lblModelCode = det.ModelCode;
        temp.lblProductName = det.ProductName;
        temp.lblSapNr = row.SapNr;
        temp.lblOrderDate = row.OrderDate === undefined ? '' : SessionUser.TenantId == 79 ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm') : moment(row.OrderDate).format('DD/MM/YYYY HH:mm');
        temp.lblMaterialOrderStatus = row.MaterialOrderStatus;
        temp.lblWorkOrderStatus = row.WorkOrderStatus;
        temp.lblDescription = row.Dsc;
        temp.lblTotalPrice = SessionUser.ServiceShopPriceVisible ? moneyFormat(
          det.PriceWithWat,
          SessionUser.TenantCode,
          SessionUser.CurrencyUnit
        ) : 0 + `${SessionUser.CurrencyUnit}`;
        json.push(temp)
      }
      ) : null))

    return json
  }

  const GetMaterialOrderParamNew = (OrderId) => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: SessionUser.ServiceShopId,
      OrderNr: OrderId
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
          setQuery(Response[0]);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);



      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const GetMaterialOrderParam = () => {
    clearPage();
    setCurrentStatus(0);
    setQuerySearchData([]);
    setQuerySearchScreenData([]);
    // GetMaterialOrderDropShipment(SearchOrderParam);
    setLoading(true);
    const StartDate = moment(StartDateSearch).format('YYYY-MM-DD');
    const EndDate = moment(EndDateSearch).format('YYYY-MM-DD');
    const Request = {
      StatusId: 0,
      StartDate,
      EndDate,
      ServiceShopId: SessionUser.ServiceShopId,
      OrderNr: SearchOrderParam
    };

    const RequestHeaders = {
      headers: { 'Content-Type': 'application/json' }
    };
    axios
      .post('/GetMaterialOrder', Request, RequestHeaders)
      .then(response => {
        const Response = response.data;
        if (Response.length > -1) {
          setQuerySearchScreenData(Response);
          setQuery(Response[0]);
        } else {
          setQuerySearchScreenData([]);
        }
        setLoading(false);
      })
      .catch(error => {
        setQuerySearchScreenData([]);
        setLoading(false);
      });
  };

  const setRetailer = param => {
    if (param.Dsc && param.Id) {
      var Data = { ...NewWorkCaseData };
      Data.Retailer = param.Dsc;
      Data.RetailerId = param.Id;
      setNewWorkCaseData(Data);
      setMaterialOrderData({
        ...MaterialOrderData,
        recipientName: param.Dsc,
        recipientAddress: param.Address,
        recipientId: param.Id
      })
    }
    else {
      var Data = { ...NewWorkCaseData };
      Data.Retailer = param;
      Data.RetailerId = 0;
      setNewWorkCaseData(Data);
      setMaterialOrderData({
        ...MaterialOrderData,
        recipientName: param
      })
    }

  };

  function setQuantityNum(value,id){
    const tmpListData = [...SparepartData];
    const index = tmpListData.findIndex(x => x.MaterialId === id);
    tmpListData[index].Quantity = value;
    tmpListData[index].Total = tmpListData[index].Quantity * tmpListData[index].PriceWithWat;
    setSparePartData(tmpListData);
  }

  function setProductMaterial(materialData) {
    if (UrunData.Model && UrunData.ModelCode) {
      if (UrunData.ProductId >= 1000000) {
        setMaterialListData([]);
        materialData.ProductId = UrunData.ProductId
        materialData.ProductName = UrunData.Model
        let result = []
        result.push(materialData)
        setMaterialListData(result);
        setinitialRows(result);
      }
    }
    else {
      setResponseType('error');
      setResponseDsc(t('lblChooseProduct'));
      setOpenSnackbar(true)
    }

  }

  const handleChange = event =>{
    setInputText(event.target.value);
  }

  const getExention = (file) => {
    const parts = file.name.split('.')
    const extension = parts[parts.length - 1]
    return EXTENSIONS.includes(extension) // return boolean
  }
  const importExcel = (e) => {
    const file = e.target.files[0]
    const reader = new FileReader()
    if (file) {
      setLoading(true)
      if (getExention(file)) {
        reader.readAsBinaryString(file)
      }
      reader.onload = (event) => {
        //parse data
        const bstr = event.target.result
        const workBook = XLSX.read(bstr, { type: "binary" })
        //get first sheet
        const workSheetName = workBook.SheetNames[0]
        const workSheet = workBook.Sheets[workSheetName]
        //convert to array
        const fileData = XLSX.utils.sheet_to_json(workSheet, { header: 1 })
        // Create excel data array
        var excelData = [];

        for (var i = 1; i < fileData.length; i++) {
          // Check related row data is empty or quantity is valid
          if((fileData[i][0] !== undefined && fileData[i][0] !== null && String(fileData[i][0]).trim() !=='') && ( fileData[i][1] !== undefined && fileData[i][1] !== null && String(fileData[i][1]).trim() !=='' && !isNaN(+String(fileData[i][1])) && parseInt(String(fileData[i][1])) > 0 ))
          {
            var quantity = parseInt(String(fileData[i][1])) > 100 ? '100' : String(fileData[i][1])
             // Add array to related row
            excelData.push({MaterialCode :String(fileData[i][0]),Quantity : quantity})
          }
        }
        
        if(excelData.length > 0)
        {
          // Get related material
          setSearcByExcelhMaterial(excelData);
        }
      }
    }
  }

  const handleCloseEdit = value => {
    setOpenEdit(false);
  }

  const blockInvalidChar = e => ['e', 'E', '+', '-','.'].includes(e.key) && e.preventDefault();

  function ShipToInformationOpen(){
    setShipToPopUp(true);
  }
  function ShipToInformationClose(){
    setShipToPopUp(false);
  }

  return (
    <Page>
      <Backdrop className={classes.backdrop} open={loading}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleSnackbarClose}
      >
        <Alert
          onClose={handleSnackbarClose}
          message={ResponseDsc}
          variant={ResponseType}
        />
      </Snackbar>
      <Container maxWidth="xl">
        <Breadcrumbs>
          <Link color="inherit">Sirius</Link>
          <Typography color="textPrimary">{t('Material_Order')}</Typography>
        </Breadcrumbs>
        <Card>
          <BottomNavigation
            value={TopBarValue}
            className={classes.stickToBottom}
            onChange={(event, newValue) => {
              setTopBarValue(newValue);
              if (newValue === 0) {

                saveWorkOrder(1);
                // KAYDET
              }
              if (newValue === 1) {
                // NEW ORDER
                clearPage();
                setCurrentStatus(0);
              }
              if (newValue === 2) {
                // İPTAL
                updateWorkOrder(newValue);
              }
              if (newValue === 3) {
                // REJECT
                updateWorkOrder(newValue);
              }
              if (newValue === 4) {
                // ONAYA GÖNDER
                updateWorkOrder(newValue);
              }
              if (newValue === 5) {
                // SAP GÖNDER
                updateWorkOrder(newValue);
              }
              if (newValue === 6) {
                // QUERY
                setQueryPopUp(true);
              }
            }}
            showLabels
          >
            {currentStatus === 5 ? (
              ''
            ) : (
              <BottomNavigationAction
                label={t('lblSave')}
                icon={<SaveIcon />}
              />
            )}
            <BottomNavigationAction
              label={t('lblNewOrder')}
              icon={<AddShoppingCartIcon />}
            />
            {(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              (currentStatus === 1 || currentStatus === 3 || currentStatus === 4) ? (
              <BottomNavigationAction
                label={t('lblCancel')}
                icon={<CancelIcon />}
              />
            ) : (
              ''
            )}
            {!(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              (currentStatus === 1 || currentStatus === 4) ? (
              <BottomNavigationAction
                label={t('lblReject')}
                icon={<CancelIcon />}
              />
            ) : (
              ''
            )}
            {(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              (currentStatus === 1 || currentStatus === 3) ? (
              <BottomNavigationAction
                style={{ display: 'none' }}
                label={t('lblSubmittedforApproval')}
                icon={<ThumbUpAltIcon />}
              />
            ) : (
              ''
            )}
            {!(SessionUser.Role === 1 || SessionUser.Role === 2) &&
              currentStatus === 4 || currentStatus === 1 || currentStatus === 4 ? (
              <BottomNavigationAction
                label={t('lblSendToSap')}
                icon={<SendIcon />}
              />
            ) : (
              ''
            )}
            {currentStatus === 5 ? (
              <BottomNavigationAction
                label={t('lblQuery')}
                icon={<FilterListIcon />}
              />
            ) : (
              <BottomNavigationAction
                label={t('lblQuery')}
                icon={<FilterListIcon />}
              />
            )}
          </BottomNavigation>
        </Card>
        <Divider />
        <Card>
          <CardHeader title={t('lblMaterialOrderInformation')}
            action={
              <Paper className={classes.searchB} elevation={1}>
                <Input
                  className={classes.searchInputB}
                  disableUnderline
                  // onKeyDown={handleKeyDown}
                  onChange={(event) => {
                    setSearchOrderParam(event.target.value);
                  }}
                  placeholder={t('lblOrderNumber')}
                />
                <SearchIcon
                  onClick={() => GetMaterialOrderParam()}
                  className={classes.searchIconB}
                />
              </Paper>
            }
          />
          <Divider />
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={4} lg={4}>
                <Card>
                  <CardContent className={classes.cardscontent}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          disabled
                          size="small"
                          id="service"
                          autoComplete="no"
                          value={MaterialOrderData.service}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              service: event.target.value
                            })}
                          fullWidth
                          label={t('lblServiceShop')}
                          variant="outlined"
                        />
                        {/* <Autocomplete
                          size="small"
                          fullWidth
                          autoSelect
                          disableClearable
                          options={ServiceShopData || []}
                          getOptionLabel={option => (option ? option.Dsc : '')}
                          value={serviceShopId || null}
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblServiceShop')}
                              variant="outlined"
                            />
                          )}
                          onChange={(event, value) => {
                            setServiceShopId(value);
                            setServiceShopShipToCode(value.ShipTo)
                            
                          }}
                        /> */}
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="status"
                          disabled
                          autoComplete="no"
                          value={MaterialOrderData.status}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              status: event.target.value
                            })}
                          fullWidth
                          label={t('lblStatus')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="orderNumber"
                          disabled
                          autoComplete="no"
                          value={MaterialOrderData.orderNumber}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              orderNumber: event.target.value
                            })}
                          fullWidth
                          label={t('lblOrderNumber')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <ThemeProvider theme={materialTheme}>
                          <MuiPickersUtilsProvider
                            utils={DateFnsUtils}
                            locale={localeMap[locale]}
                          >
                            <KeyboardDatePicker
                              color="primary"
                              inputVariant="outlined"
                              id="orderDate"
                              disabled
                              size="small"
                              invalidDateMessage={t('hatali_tarih')}
                              format={SessionUser.TenantId ==79 ? "MM.dd.yyyy" : "dd.MM.yyyy"} 
                              fullWidth
                              autoComplete="off"
                              label={t('lblOrderDate')}
                              variant="outlined"
                              value={MaterialOrderData.orderDate}
                              onChange={e => SetDate(e)}
                              KeyboardButtonProps={{
                                'aria-label': 'change date'
                              }}
                            />
                          </MuiPickersUtilsProvider>
                        </ThemeProvider>
                      </Grid>
                      <Grid item xs={11} sm={11} lg={11}>
                        <TextField
                          size="small"
                          id="sapNumber"
                          disabled
                          autoComplete="no"
                          value={MaterialOrderData.sapNumber}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              sapNumber: event.target.value
                            })}
                          fullWidth
                          label={t('lblSapNumber')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={1} sm={1} lg={1}>
                        {MaterialOrderData.sapNumber !== "" ? 
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <ControlCameraIcon
                                size="small"
                                color="primary"
                                style={{ color: '#3399FF' }}                               
                                onClick={() => ErpStatusPopup(MaterialOrderData.sapNumber)}
                              />
                            </Box>
                          } 
                        /> : 
                        <FormControlLabel
                          disabled
                          control={
                            <Box p={0.8}>
                              <ControlCameraIcon
                                size="small"
                                color="primary"
                                style={{ color: '#93b9c7' }}                               
                              />
                            </Box>
                          } 
                      />}
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
 
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <Card>
                  <CardContent className={classes.cardscontent}>
                    <Grid container spacing={1}>
                      <Grid item xs={6} sm={6} lg={6}>  
                        <TextField
                          disabled
                          size="small"
                          id="jobNumber"
                          autoComplete="no"
                          type="number"
                          value={MaterialOrderData.jobNumber}
                          onKeyDown={blockInvalidChar}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              jobNumber: event.target.value
                            })}
                          fullWidth
                          label={t('lblWorkOrderId')}
                          variant="outlined"
                          onInput={(e)=>{ 
                            e.target.value = Math.max(0, parseInt(e.target.value) ).toString().slice(0,10)
                          }}
                          min={0}
                        />
                      </Grid>
                      <Grid item xs={6} sm={6} lg={6}>
                        <TextField
                          size="small"
                          id="poNumber"
                          autoComplete="no"
                          type="string"
                          value={MaterialOrderData.poNumber}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              poNumber: event.target.value.slice(0, 20)
                            })}
                          fullWidth
                          label={t('PO Number')}
                          variant="outlined"
                        />
                      </Grid>
                      <Grid item xs={12} sm={12} lg={12}>
                        <TextField
                          size="small"
                          id="description"
                          multiline
                          rows={10}
                          autoComplete="no"
                          value={MaterialOrderData.description}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              description: event.target.value
                            })}
                          fullWidth
                          label={t('lblDescription')}
                          variant="outlined"
                        />
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <Card>
                  <CardContent className={classes.cardscontent}>
                    <Grid container spacing={1}>
                      <Grid item xs={12} sm={12} lg={12}>
                        {/* <TextField
                          size="small"
                          id="recipientName"
                          autoComplete="no"
                          value={MaterialOrderData.recipientName}
                          onChange={event =>
                            setMaterialOrderData({
                              ...MaterialOrderData,
                              recipientName: event.target.value
                            })}
                          fullWidth
                          label={t('lblRecipientName')}
                          variant="outlined"
                        /> */}
                        {/* <RetailerSearchShipTo
                          setRetailer={setRetailer}
                          label={"lblRetailerShipTo"}
                          value={
                            {
                              Dsc: MaterialOrderData.recipientName || '',
                              Id: MaterialOrderData.recipientId || 0
                            } || ''
                          }
                          searchParam = {search}
                          shipTo = {ServiceShopShipToCode}
                          setMainScreenLoading = {setLoading}
                        /> */}
                        <Autocomplete
                          size="small"
                          fullWidth
                          autoSelect
                          disableClearable
                          options={retailerData || []}
                          getOptionLabel={option => (option ? option.Dsc : '')}
                          value={selectedRetailer || null}
                          disabled = { SessionUser.TenantId == 71 || SessionUser.TenantId == 72 }
                          renderInput={params => (
                            <TextField
                              {...params}
                              label={t('lblRetailerShipTo')}
                              variant="outlined"
                            />
                          )}
                          onChange={handleRetailerChange}
                        />
                      </Grid>
                      {/* Dropshipment tamamlandıktan sonra açılacak. */}
                      {/* <Grid item xs={2} sm={2} lg={2}>
                        <Button onClick={ShipToInformationOpen}><LocalShippingIcon/></Button>
                      </Grid> */}
                      <Dialog
                        open={ShipToPopUp}
                        fullWidth
                        maxWidth="lg"
                        onClose={ShipToInformationClose}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                      >
                        <Grid container >
                          <Grid xs={1} sm={1} lg={1}></Grid>
                          <Grid item xs={10} sm={10} lg={10}>
                            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                                {t('lblDropShipment')}
                            </DialogTitle>
                          </Grid>
                          <Grid xs={1} sm={1} lg={1}>
                            <DialogActions>
                              <IconButton
                                color="primary"
                                onClick={ShipToInformationClose}
                                aria-label="upload picture"
                                component="span">
                                <CloseIcon />
                              </IconButton>
                            </DialogActions>
                          </Grid>
                        </Grid>
                        <DialogContent>
                          <Grid container direction='row' spacing={2}>
                            <Grid item xs={6} sm={6} lg={6}>
                                <TextField
                                  value={title}
                                  onChange={(e)=>setTitle(e.target.value)}
                                  required
                                  variant="outlined"
                                  fullWidth
                                  id="outlined-multiline-flexible"
                                  placeholder="Title"
                                  size='small'
                                />
                              </Grid>
                              <Grid item xs={6} sm={6} lg={6}>
                                <TextField
                                  value={name}
                                  onChange={(e)=>setName(e.target.value)}
                                  required
                                  variant="outlined"
                                  fullWidth
                                  id="outlined-multiline-flexible"
                                  placeholder="Name"
                                  size='small'
                                />
                              </Grid>
                              <Grid item xs={6} sm={6} lg={6}>
                              <TextField
                                value={street}
                                onChange={(e)=>setStreet(e.target.value)}
                                required
                                variant="outlined"
                                fullWidth
                                id="outlined-multiline-flexible"
                                placeholder="Street/House Number"
                                size='small'
                              />
                            </Grid>
                            <Grid item xs={6} sm={6} lg={6}>
                              <TextField
                                value={district}
                                onChange={(e)=>setDistrict(e.target.value)}
                                required
                                variant="outlined"
                                fullWidth
                                id="outlined-multiline-flexible"
                                placeholder="District"
                                size='small'
                              />
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3}>
                              <TextField
                                value={postalCode}
                                onChange={(e)=>setPostalCode(e.target.value)}
                                required
                                variant="outlined"
                                fullWidth
                                id="outlined-multiline-flexible"
                                placeholder="Postal Code"
                                size='small'
                              />
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3}>
                              <TextField
                                value={city}
                                onChange={(e)=>setCity(e.target.value)}
                                required
                                variant="outlined"
                                fullWidth
                                id="outlined-multiline-flexible"
                                placeholder="City"
                                size='small'
                              />
                            </Grid>
                            <Grid item xs={3} sm={3} lg={3}>
                              <TextField
                                value={country}
                                onChange={(e)=>setCountry(e.target.value)}
                                required
                                variant="outlined"
                                fullWidth
                                id="outlined-multiline-flexible"
                                placeholder="Country"
                                size='small'
                              />
                              </Grid>
                              <Grid item xs={3} sm={3} lg={3}>
                              <TextField
                                value={region}
                                onChange={(e)=>setRegion(e.target.value)}
                                required
                                variant="outlined"
                                fullWidth
                                id="outlined-multiline-flexible"
                                placeholder="Region"
                                size='small'
                              />
                            </Grid>
                          </Grid>
                          <br></br>
                          <br></br>
                        </DialogContent>
                      </Dialog>
                      <Grid item xs={12} sm={12} lg={12}>
                      <TextField
                        size="small"
                        id="recipientAddress"
                        autoComplete="no"
                        multiline
                        rows={10}
                        value={address}
                        onChange={handleAddressChange}
                        fullWidth
                        label={t('lblRetailerShipToAddress')}
                        variant="outlined"
                      />
                      </Grid> 
                    </Grid>             
                  </CardContent>
                </Card>
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                  <Alert
                    message={'The prices are reflected as list prices. Special prices will be updated on the order confirmation.'}
                    variant={'warning'}
                  />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
        <Card>
          <BottomNavigation>
            <ExcelExport JsonData={exportMaterialData(SparepartData)} ButtonType={1} />
            <BottomNavigationAction
              onClick={() => setSelectedMaterialPopup(true)}
              showLabel
              label={t('Add Material')}
              icon={<AddBoxIcon />}
            />
            <BottomNavigationAction
               onClick={() => setSelectedProductMaterialPopup(true)}
               showLabel
               label={t('Add Material From Product')}
               icon={<AddBoxIcon />}
            />
          </BottomNavigation>
          <Divider />
          <CardContent>
            <TableContainer component={Paper}>
              <Table
                className={classes.table}
                size="small"
                aria-label="a dense table"
              >
                <TableHead>
                  <TableRow>
                    <TableCell />
                    <TableCell />
                    <TableCell align="left">{t('lblProductName')}</TableCell>
                    <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                    <TableCell align="left">{t('lblMaterial')}</TableCell>
                    <TableCell align="right">{t('lblQuantity')}</TableCell>
                    <TableCell align="right">
                      {t('lblOriginalQuantity')}
                    </TableCell>
                    <TableCell align="right">{t('lblPrice')}</TableCell>
                    <TableCell align="right">{SessionUser.TenantId == 71 || SessionUser.TenantId == 72 ? t('lblPriceWithGST') : t('lblPriceWithVat')}</TableCell>
                    <TableCell align="right">{t('lblTotal')}</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {SparepartData.map(row => (
                    <TableRow key={row.MaterialId}>
                      <TableCell align="center">
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <DeleteIcon
                                size="small"
                                color="primary"
                                style={{ color: 'red' }}
                                onClick={() => deleteFromMaterialTable(row)}
                              />
                            </Box>
                          }
                        />
                      </TableCell>
                      <TableCell align="center">
                        <FormControlLabel
                          control={
                            <Box p={0.8}>
                              <LocalGroceryStoreIcon
                                size="small"
                                color="primary"
                                style={{ color: '#3399FF' }}
                                onClick={() => StokControlPopup(row)}
                              />
                            </Box>
                          }

                        />
                      </TableCell>
                      <TableCell align="left">{row.ProductName}</TableCell>
                      <TableCell align="left" component="th" scope="row">
                        {row.MaterialCode}
                      </TableCell>
                      <TableCell align="left">{row.MaterialDesc}</TableCell>
                      <TableCell align="right">
                        <Input style={{width:'45px', textAlign:'center',backgroundColor: QuantityState.backgroundColor }} type='number' textAlign='center' value={row.Quantity} onChange={(e)=>handleQuantityChange(e,row)} />
                      </TableCell>
                      <TableCell align="right">{row.UseQuantity}</TableCell>
                      <TableCell align="right">
                        {SessionUser.ServiceShopPriceVisible ? moneyFormat(
                          row.Price,
                          SessionUser.TenantCode,
                          SessionUser.CurrencyUnit
                        ) : 0}
                        {`${SessionUser.CurrencyUnit}`}
                      </TableCell>
                      <TableCell align="right">
                        {SessionUser.ServiceShopPriceVisible ? moneyFormat(
                          row.PriceWithWat,
                          SessionUser.TenantCode,
                          SessionUser.CurrencyUnit
                        ) : 0}
                        {`${SessionUser.CurrencyUnit
                          }`}
                      </TableCell>
                      <TableCell align="right">
                        {SessionUser.ServiceShopPriceVisible ? moneyFormat(
                          row.Total,
                          SessionUser.TenantCode,
                          SessionUser.CurrencyUnit
                        ) : 0}
                        {`${SessionUser.CurrencyUnit}`}
                      </TableCell>
                    </TableRow>
                  ))}
                  <TableRow>
                    <TableCell align="center" />
                    <TableCell align="center" />
                    <TableCell align="center" />
                    <TableCell align="center" />
                    <TableCell align="right">
                      <b>{t('lblTotal')}</b>
                    </TableCell>
                    <TableCell align="center">
                      <b>
                        { SparepartData.reduce(
                          (n, { Quantity }) => n == 0 ? Quantity : n + Quantity,
                          0
                        )}
                      </b>
                    </TableCell>
                    <TableCell align="center" />
                    <TableCell align="right">
                      <b>
                        {`${SparepartData.reduce(
                          (n, { Price }) => n + (SessionUser.ServiceShopPriceVisible?Price:0),
                          0
                        ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                      </b>
                    </TableCell>
                    <TableCell align="right">
                      <b>
                        {`${SparepartData.reduce(
                          (n, { PriceWithWat }) => n + (SessionUser.ServiceShopPriceVisible?PriceWithWat:0),
                          0
                        ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                      </b>
                    </TableCell>
                    <TableCell align="right">
                      <b>
                        {`${SparepartData.reduce(
                          (n, { Total }) => n + (SessionUser.ServiceShopPriceVisible?Total:0),
                          0
                        ).toFixed(2)} ${SessionUser.CurrencyUnit}`}
                      </b>
                    </TableCell>
                  </TableRow>
                </TableBody>
              </Table>
            </TableContainer>
          </CardContent>
        </Card>
      </Container>
        <EditMaterial
        open={openEdit}
        value={1}
        min={1}
        max={99}
        onClose={handleCloseEdit}
        materialId = {materialId}
        materialCode = {materialCode}
        materialDesc = {materialDesc}
        sparePartMessage={sparePartMessage}
        setQuantityNum = {setQuantityNum}
      />
      {/* Add Material From Product BOM */}
      <Dialog
        open={SelectedProductMaterialPopup}
        fullWidth
        maxWidth="lg"
        onClose={() => setSelectedProductMaterialPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description" >
      <Grid container >
          <Grid xs={1} sm={1} lg={1}></Grid>
          <Grid item xs={10} sm={10} lg={10}>
          <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
          {t('Add Material From Product BOM')}
        </DialogTitle>
          </Grid>
          <Grid xs={1} sm={1} lg={1}>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => setSelectedProductMaterialPopup(false)}
                aria-label="upload picture"
                component="span">
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Grid>
      </Grid>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <UrunSearch
                    setModel={setModel}
                    value={
                      {
                        KUL_MODEL_KODU: UrunData.ModelCode,
                        ACIKLAMA: UrunData.Model
                      } || ''
                    }
                    searchParam={search}
                  />
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <ProductMaterialSearch
                    setProductMaterial={setProductMaterial}
                    materialIsVisible={(UrunData.Model && UrunData.ModelCode && UrunData.ProductId >= 1000000) ? true : false}
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={4} sm={4} lg={4}>
                  <SearchBar
                    inputSizeSmall
                    value={searched}
                    onChange={searchVal => requestSearch(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                  />
                </Grid>
                {/* <Grid item xs={4} sm={4} lg={4}>
                  <input
                    id="FileInput"
                    type='file'
                    onChange={importExcel}
                    hidden
                    accept=".xlsx, .xls, .xml"
                  >
                  </input>
                  <label htmlFor="FileInput">
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      fullWidth
                      component="span"
                    >
                      {t('lblChooseFile')}
                    </Button>
                  </label>
                </Grid> */}
                <Grid item xs={12} sm={12} lg={12}>
                  <TableContainer component={Paper}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      size="small"
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell />
                          <TableCell align="left">
                            {t('lblMaterialCode')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblDescription')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblRef')}
                          </TableCell>
                          <TableCell align="right">{t('lblPrice')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? MaterialListData.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          : MaterialListData
                        ).map(row => (
                          <TableRow key={row.MaterialId} style={SparepartData.includes(row) ? {backgroundColor:'#DEF5E5'} : {}}>
                            <TableCell
                              align="center"
                              className={classes.tableCellMaterial}
                            >
                              <FormControlLabel
                                control={
                                  <ImageSearchIcon
                                    onClick={() =>
                                      malzemeGosterMaterial(row.MaterialCode)
                                    }
                                    color="primary"
                                  >
                                  </ImageSearchIcon>
                                }
                              />
                            </TableCell>
                            <TableCell align="center">
                              <FormControlLabel
                                control={
                                  <AddBoxIcon
                                    color="primary"
                                    onClick={() => addToMaterialTable(row)}
                                  />
                                }
                              />
                            </TableCell>
                            <TableCell align="left">
                              {row.MaterialCode}
                            </TableCell>
                            <TableCell align="left">
                              {row.MaterialDesc}
                            </TableCell>
                            <TableCell align="left">
                              {row.Ref}
                            </TableCell>
                            <TableCell align="right">
                              {`${SessionUser.ServiceShopPriceVisible ? row.PriceWithWat.toFixed(2) : 0} ${SessionUser.CurrencyUnit
                                }`}
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10]}
                      component="div"
                      count={MaterialListData.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
        <DialogActions/>
      </Dialog>
      {/* Material Add */}
      <Dialog
        open={SelectedMaterialPopup}
        fullWidth
        maxWidth="lg"
        onClose={() => setSelectedMaterialPopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container >
          <Grid xs={1} sm={1} lg={1}></Grid>
          <Grid item xs={10} sm={10} lg={10}>
            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {t('lblMaterialChoose')}
            </DialogTitle>
          </Grid>
          <Grid xs={1} sm={1} lg={1}>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => setSelectedMaterialPopup(false)}
                aria-label="upload picture"
                component="span">
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Grid>
        </Grid>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card>
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={12} lg={12}>
                  <OutlinedInput
                    id="outlined-adornment"
                    fullWidth
                    placeholder={t('Please Enter Material Code Or Name Or SKU (For BOM) Then Click The Button')}
                    value={inputText}
                    onChange={handleChange}
                    endAdornment={
                      <InputAdornment position="end">
                        <IconButton type="button" sx={{ p: '10px' }} aria-label="search"
                        onClick={setSearchMaterial}
                        >
                          <SearchIcon />
                        </IconButton>
                      </InputAdornment>
                    }
                  />
                </Grid>
              </Grid>
            </CardContent>
            <Divider />
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={4} sm={4} lg={4}>
                  <SearchBar
                    value={searched}
                    onChange={searchVal => requestSearch2(searchVal)}
                    onCancelSearch={() => cancelSearch()}
                    style={{ margin: '0 auto', maxWidth: 800, maxHeight: 37 }}
                  />
                </Grid>
                <Grid item xs={4} sm={4} lg={4}>
                  <input
                    id="FileInput"
                    type='file'
                    onChange={importExcel}
                    hidden
                    accept=".xlsx, .xls, .xml"
                  >
                  </input>
                  <label htmlFor="FileInput">
                    <Button
                      variant="contained"
                      color="primary"
                      size="small"
                      fullWidth
                      component="span"
                    >
                      {t('lblChooseFile')}
                    </Button>
                  </label>
                </Grid>
                <Grid item xs={4} sm={4} lg={4}>
                  <ExcelExport JsonData={exportExcelExample} ButtonType={5} ButtonText={'EXCEL EXAMPLE'}/>
                </Grid>
                <Grid item xs={12} sm={12} lg={12}>
                  <TableContainer component={Paper}>
                    <Table
                      stickyHeader
                      className={classes.table}
                      size="small"
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell />
                          <TableCell />
                          <TableCell align="left">
                            {t('lblMaterialCode')}
                          </TableCell>
                          <TableCell align="left">
                            {t('lblDescription')}
                          </TableCell>
                          <TableCell align="right">{t('lblPrice')}</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {(rowsPerPage > 0
                          ? MaterialListData2.slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          : MaterialListData2
                        ).map(row => (
                          <TableRow key={row.MaterialId} style={SparepartData.includes(row) ? {backgroundColor:'#DEF5E5'} : {}}>
                            <TableCell
                              align="center"
                              className={classes.tableCellMaterial}
                            >
                              <FormControlLabel
                                control={
                                  <ImageSearchIcon
                                    onClick={() =>
                                      malzemeGosterMaterial(row.MaterialCode)
                                    }
                                    color="primary"
                                  >
                                  </ImageSearchIcon>
                                }
                              />
                            </TableCell>
                            <TableCell align="center">
                              <FormControlLabel
                                control={
                                  <AddBoxIcon
                                    color="primary"
                                    onClick={() => addToMaterialTable(row)}
                                  />
                                }
                              />
                            </TableCell>
                            <TableCell align="left">
                              {row.MaterialCode}
                            </TableCell>
                            <TableCell align="left">
                                {row.MaterialDesc}
                            </TableCell>
                            <TableCell align="right">
                              {`${row.PriceWithWat.toFixed(2)} ${SessionUser.CurrencyUnit
                                }`}  
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    <TablePagination
                      rowsPerPageOptions={[5, 10]}
                      component="div"
                      count={MaterialListData2.length}
                      rowsPerPage={rowsPerPage}
                      page={page}
                      onChangePage={handleChangePage}
                      onChangeRowsPerPage={handleChangeRowsPerPage}
                    />
                  </TableContainer>
                </Grid>
              </Grid>
            </CardContent>
          </Card>
        </Container>
        <DialogActions/>
      </Dialog>
      <Dialog
        open={MissingMaterialsPopUp}
        fullWidth
        maxWidth="lg"
        onClose={() => missingMaterialsPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container >
          <Grid xs={1} sm={1} lg={1}></Grid>
          <Grid item xs={10} sm={10} lg={10}>
            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
                {t('Missing Materials')}
            </DialogTitle>
          </Grid>
          <Grid xs={1} sm={1} lg={1}>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => missingMaterialsPopUp(false)}
                aria-label="upload picture"
                component="span">
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Grid>
        </Grid>
        <Container maxWidth="xl" spacing={1}>
        <label style={{ color: 'red' }}>The following material codes were not found or defined in your region</label>
          <Divider />
          <Paper style={{maxHeight: 300, overflow: 'auto'}}>
          <List>
          {MissingMaterials.map((item) => 
            <ListItem>
              <ListItemText >{item.MaterialCode}</ListItemText >
            </ListItem>
           )}
            </List>
          </Paper>
        </Container>
        <DialogActions/>
      </Dialog>
     
      <Dialog
        open={QueryPopUp}
        fullWidth={true}
        maxWidth={'xl'}
        onClose={() => setQueryPopUp(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <Grid container >
          <Grid xs={1} sm={1} lg={1}></Grid>
          <Grid item xs={10} sm={10} lg={10}>
            <DialogTitle id="alert-dialog-title" style={{ textAlign: 'center' }}>
              {t('lblQuery')}
            </DialogTitle>
          </Grid>
          <Grid xs={1} sm={1} lg={1}>
            <DialogActions>
              <IconButton
                color="primary"
                onClick={() => setQueryPopUp(false)}
                aria-label="upload picture"
                component="span"
              >
                <CloseIcon />
              </IconButton>
            </DialogActions>
          </Grid>
      </Grid>
        <Container maxWidth="xl" spacing={1}>
          <Divider />
          <Card >
            <CardContent>
              <Grid container spacing={1}>
                <Grid item xs={12} sm={3} lg={3}>
                  <Autocomplete
                    size="small"
                    fullWidth
                    autoSelect
                    disableClearable
                    options={ServiceShopData}
                    getOptionLabel={option => (option ? option.Dsc : '')}
                    value={serviceShopId}
                    renderInput={params => (
                      <TextField
                        {...params}
                        label={t('lblServiceShop')}
                        variant="outlined"
                      />
                    )}
                    onChange={(event, value) => {
                      setServiceShopId(value);
                    }}
                    disabled={DisabledControl}
                  />
                </Grid>
                <Grid item xs={12} sm={1} lg={1}>
                  <TextField
                    size="small"
                    fullWidth
                    select
                    label={t('lblStatus')}
                    id="StatusId"
                    variant="outlined"
                    value={selectedStatus.Id}
                  >
                    {statusList?.map(h => {
                      return (
                        <MenuItem
                          onClick={() => changeSelectedStatus(h)}
                          key={h.Id}
                          value={h.Id}
                        >
                          {h.Name}
                        </MenuItem>
                      );
                    })}
                  </TextField>
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <KeyboardDatePicker
                        color="primary"
                        inputVariant="outlined"
                        id="orderDate"
                        size="small"
                        invalidDateMessage={t('hatali_tarih')}
                        format="dd.MM.yyyy"
                        fullWidth
                        label={t('BaslangicTarihi')}
                        variant="outlined"
                        value={StartDateSearch}
                        onChange={e => handleChangeStartDateSearch(e)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <ThemeProvider theme={materialTheme}>
                    <MuiPickersUtilsProvider
                      utils={DateFnsUtils}
                      locale={localeMap[locale]}
                    >
                      <KeyboardDatePicker
                        color="primary"
                        inputVariant="outlined"
                        id="orderDate"
                        size="small"
                        invalidDateMessage={t('hatali_tarih')}
                        format="dd.MM.yyyy"
                        fullWidth
                        autoComplete="off"
                        label={t('BitisTarihi')}
                        variant="outlined"
                        value={EndDateSearch}
                        onChange={e => handleChangeEndDateSearch(e)}
                        KeyboardButtonProps={{
                          'aria-label': 'change date'
                        }}
                      />
                    </MuiPickersUtilsProvider>
                  </ThemeProvider>
                </Grid>
                <Grid item xs={12} sm={2} lg={2}>
                  <TextField
                    size="small"
                    id="orderNumber"
                    autoComplete="no"
                    value={MaterialOrderData.orderNumber}
                    onChange={event =>
                      setMaterialOrderData({
                        ...MaterialOrderData,
                        orderNumber: event.target.value
                      })}
                    fullWidth
                    label={t('lblOrderNumber')}
                    variant="outlined"
                  />
                </Grid>
                <Grid item xs={12} sm={2} lg={1}>
                  <Button
                    variant="contained"
                    color="primary"
                    fullWidth
                    endIcon={<SearchIcon />}
                    onClick={GetMaterialOrderRequest}
                  >
                    {t('search')}
                  </Button>
                </Grid>
                <Grid item xs={12} sm={2} lg={1}>
                  <ExcelExport JsonData={exportData(QuerySearchScreenData)} />
                </Grid>

              </Grid>
            </CardContent>
            <CardContent className={classes.cardscontent}>
              <TableContainer component={Paper}>
                <Table
                  className={classes.table}
                  size="small"
                  aria-label="a dense table"
                >
                  <TableHead>
                    <TableRow>
                      <TableCell align="left">{t('lblJobNumber')}</TableCell>
                      <TableCell align="left">{t('PO Number')}</TableCell>
                      <TableCell align="left">{t('lblServiceShop')}</TableCell>
                      <TableCell align="left">{t('lblOrderNumber')}</TableCell>
                      <TableCell align="left">{t('lblRecipientName')}</TableCell>
                      <TableCell align="left">{t('lblRecipientAddress')}</TableCell>
                      <TableCell align="left">{t('lblMaterialCode')}</TableCell>
                      <TableCell align="left">{t('lblMaterial')}</TableCell>
                      <TableCell align="left">{t('lblQuantity')}</TableCell>
                      <TableCell align="left">{t('lblOrderDate')}</TableCell>
                      <TableCell align="left">{t('lblModelCode')}</TableCell>
                      <TableCell align="left">{t('lblProductName')}</TableCell>
                      <TableCell align="left">{t('lblSapNumber')}</TableCell>
                      <TableCell align="left">{t('lblStatus')}</TableCell>
                      <TableCell align="left">{t('lblWorkOrderStatus')}</TableCell>
                      <TableCell align="left">{t('lblDescription')}</TableCell>
                      <TableCell align="left">{t('lblTotal')}</TableCell>
                      <TableCell align="left">{t('lblWarrantyType')}</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {QuerySearchScreenData ? QuerySearchScreenData.map(row => (
                      row.MaterialOrderDetails ? row.MaterialOrderDetails.map(det => (
                        <TableRow
                          key={row.MaterialOrderId}
                          hover
                          classes={{ hover: classes.hover }}
                          className={classes.tableRow}
                          onClick={() => setQuery(row)}
                        >
                          <TableCell align="left">
                            {row.WorkOrderId}
                          </TableCell>
                          <TableCell align="left">
                            {row.PONumber}
                          </TableCell>
                          <TableCell align="left">
                            {`${row.SourceServiceShopCode} ${row.ServiceShop}`}
                          </TableCell>
                          <TableCell align="left">
                            {row.MaterialOrderId}
                          </TableCell>
                          <TableCell align="left">
                            {row.RecipientDsc}
                          </TableCell>
                          <TableCell align="left">
                            {row.RecipientAddress}
                          </TableCell>
                          <TableCell align="left">
                            {det.MaterialCode}
                          </TableCell>
                          <TableCell align="left">
                            {det.Material}
                          </TableCell>
                          <TableCell align="left">
                            {det.Qty}
                          </TableCell>
                          <TableCell align="left">{row.OrderDate === undefined ? '' : SessionUser.TenantId == 79 ? moment(row.OrderDate).format('MM/DD/YYYY HH:mm') : moment(row.OrderDate).format('DD/MM/YYYY HH:mm')}</TableCell>

                          <TableCell align="left">{det.ModelCode}</TableCell>
                          <TableCell align="left">{det.ProductName}</TableCell>
                          <TableCell align="left">
                            {row.SapNr}
                          </TableCell>
                          <TableCell align="left">
                            {det.MaterialOrderDetailStatus}
                          </TableCell>
                          <TableCell align="left">
                            {row.WorkOrderStatus}
                          </TableCell>
                          <TableCell align="left">{row.Dsc}</TableCell>
                          <TableCell align="left">
                            {SessionUser.ServiceShopPriceVisible ?  moneyFormat(
                              det.PriceWithWat*det.Qty,
                              SessionUser.TenantCode,
                              SessionUser.CurrencyUnit
                            ) : 0}
                            {`${SessionUser.CurrencyUnit}`}
                          </TableCell>
                          <TableCell align="left">{row.WarrantyType}</TableCell>
                        </TableRow>
                      )) : null
                    ))
                      : null}
                  </TableBody>
                </Table>
              </TableContainer>
            </CardContent>
          </Card>
        </Container>
        <DialogActions/>         
      </Dialog>
      <Dialog
        open={ImagePopup}
        fullWidth
        maxWidth="sm"
        onClose={() => setImagePopup(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <img width="auto" height="auto" src={ImageUrl} style={{ border: 'none' }} onclick={() => setImagePopup(false)}></img>
      </Dialog>

      <Dialog
        open={stokOpen}
        onClose={() => setStokOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblMaterialStockSituation')}
          <Divider />
        </DialogTitle>
        <DialogContent>
            <List component="div" dense>
              {loading ? (
                <CircularProgress
                  status="loading"
                  style={{ marginLeft: '50%' }}
                />
              ) : (
                stokData.map(s => {
                  return (
                    <React.Fragment>
                      <ListItem
                        fullWidth
                        alignItems="flex-start"
                        key={materialAvailabilityCode}
                      >
                        <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                        <ListItemText
                          primary={
                            <Typography
                              key={materialAvailabilityCode}
                              variant="body1"
                              className={classes.nestedRight}
                            >
                              <b>{materialAvailabilityCode}</b>
                            </Typography>
                          }
                          secondary={
                            <React.Fragment>
                              <Typography
                                component="span"
                                variant="h6"
                                className={classes.inline}
                                color="textPrimary"
                              >
                                {t('StorageDesc')} : {s.StorageDesc}
                                <br />
                                {t('StorageLocDesc')} : {s.StorageLocDesc}
                                <br />
                                {t('lblAdet')} : {s.Quantity}
                                <br />
                                {t('Tarih')} : {s.Date}
                              </Typography>
                            </React.Fragment>
                          }
                        />
                      </ListItem>
                      <Divider variant="inset" component="li" />
                    </React.Fragment>
                  );
                })
              )}
            </List>
          </DialogContent>
        <DialogActions>
          <Button onClick={() => setStokOpen(false)} color="primary">
            {t('lblOk')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={ErpStatusOpen}
        onClose={() => setErpStatusOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
      >
        <DialogTitle id="alert-dialog-title">
          {t('lblErpStatus')}
          <Divider />
        </DialogTitle>
        <DialogContent>
          <List component="div" dense>
            {loading ? (
              <CircularProgress
                status="loading"
                style={{ marginLeft: '50%' }}
              />
            ) : (
              ErpStatusData?.orders?.map(s => {
                return (
                  <React.Fragment>
                    <ListItem
                      fullWidth
                      alignItems="flex-start"
                      key={s.orderHeader.ORDER_NO}
                    >
                      <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                      <ListItemText
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {t('lblSapNr')} : {s.orderHeader.ORDER_NO}
                              <br />
                              {t('lblWorkOrder')} : {s.orderHeader.PO_NUMBER}
                              <br />
                              {t('lblStatus')} : {s.orderHeader.ORDERAPPROVED}
                              <br />
                              {t('lblPrice')} : {s.orderHeader.TOTAL_VALUE + ' ' + s.orderHeader.CURRENCY}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                    <ListItem
                      fullWidth
                      alignItems="flex-start"
                      key={s.invoices[0]?.invoiceHeader?.ORDER_NO}
                    >
                      <ListItemAvatar>{getStokColor(s)}</ListItemAvatar>
                      <ListItemText
                        secondary={
                          <React.Fragment>
                            <Typography
                              component="span"
                              variant="h6"
                              className={classes.inline}
                              color="textPrimary"
                            >
                              {t('lblInvoiceNumber')} : {s.invoices[0]?.invoiceHeader?.INVOICE_NO}
                              <br />
                              {t('lblInvoiceDate')} : {s.invoices[0]?.invoiceHeader?.INVOICE_DATE}
                              <br />
                              {t('lblPrice')} : {s.invoices[0]?.invoiceHeader?.INVOICE_AMOUNT + ' ' + s.invoices[0]?.invoiceHeader?.CURRENCY}
                            </Typography>
                          </React.Fragment>
                        }
                      />
                    </ListItem>

                    <Divider variant="inset" component="li" />

                  </React.Fragment>
                );
              })
            )}
          </List>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setErpStatusOpen(false)} color="primary">
            {t('lblOk')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openWarning}
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title" color="primary">
          {t('Bilgilendirme')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            {Uyari}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setopenWarning(false)} color="primary">
            {t('lblOkey')}
          </Button>
        </DialogActions>
      </Dialog>
    </Page >
  );
};


export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest,
  resetDefects,
  resetLabours,
  resetMaterials
})(MaterialOrder);
